module.exports = __webpack_public_path__ + "img/Rectangle 132.8c44ec64.png";